export const getSectionsToRenderByUpdate = () => [
  {
    id: 'cart-header',
    section: 'cart-header',
    selector: '.Cart__item-count',
  },
  {
    id: 'cart-indicator',
    section: 'cart-indicator',
    selector: '.shopify-section',
    reused: true, // This is a reused section across the site
  },
  {
    id: 'cart-shipping',
    section: document.getElementById('cart-shipping').dataset.id,
    selector: '[data-cart-total-container]',
  },
  {
    id: 'cart-totals',
    section: 'cart-totals',
    selector: '.CartTotals__container',
  },
  {
    id: 'cart-items',
    section: document.getElementById('cart-items').dataset.id,
    selector: '[data-cart]',
  },
];

export const getSectionsToRenderByAdd = () => [
  {
    id: 'cart-header',
    section: 'cart-header',
    selector: '.Cart__item-count',
  },
  {
    id: 'cart-indicator',
    section: 'cart-indicator',
    selector: '.shopify-section',
    reused: true, // This is a reused section across the site
  },
  {
    id: 'cart-shipping',
    section: document.getElementById('cart-shipping').dataset.id,
    selector: '[data-cart-total-container]',
  },
  {
    id: 'cart-totals',
    section: 'cart-totals',
    selector: '.CartTotals__container',
  },
  {
    id: 'cart-items',
    section: document.getElementById('cart-items').dataset.id,
    selector: '[data-cart]',
  },
];

export const getSectionsToRenderByPDP = () => [
  {
    id: 'cart-indicator',
    section: 'cart-indicator',
    selector: '.shopify-section',
    reused: true, // This is a reused section across the site
  },
  {
    id: 'cart-atb',
    section: 'cart-atb',
    selector: '.shopify-section',
  },
];
